import { render, staticRenderFns } from "./VueCarousel.vue?vue&type=template&id=44025732"
import script from "./VueCarousel.vue?vue&type=script&lang=js"
export * from "./VueCarousel.vue?vue&type=script&lang=js"
import style0 from "./VueCarousel.vue?vue&type=style&index=0&id=44025732&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports